import { FC } from 'react';

import { Eyebrow, Icon, Stack, Tooltip } from '@servicetitan/design-system';

import { ApiGroup } from '../../api/app.api';
import { CopyBox } from '../../common';
import { ResourceOwnerMenu } from './resource-owner-menu';

export const ResourceOwnerInfo: FC<{
    selectedApiGroup: ApiGroup;
    selectedResourceOwner: string;
}> = ({ selectedApiGroup, selectedResourceOwner }) => {
    return (
        <Stack direction="column">
            <Stack.Item>
                <Stack direction="row" alignItems="flex-end" spacing={1}>
                    <Stack.Item>
                        <Eyebrow>{`Your ${selectedApiGroup.displayName}${
                            selectedApiGroup.displayName !== selectedApiGroup.resourceOwnerTerm
                                ? ' ' + selectedApiGroup.resourceOwnerTerm
                                : ''
                        } ID`}</Eyebrow>
                    </Stack.Item>
                    <Stack.Item>
                        <Tooltip text="Apps use this ID to access your data.">
                            <Icon name="help" />
                        </Tooltip>
                    </Stack.Item>
                </Stack>
            </Stack.Item>
            <Stack.Item>
                <CopyBox
                    size={10}
                    value={selectedResourceOwner}
                    action={
                        selectedApiGroup.assignedResourceOwners.length > 1 ? (
                            <ResourceOwnerMenu
                                selectedApiGroup={selectedApiGroup}
                                selectedResourceOwner={selectedResourceOwner}
                                assignedResourceOwners={selectedApiGroup.assignedResourceOwners}
                            />
                        ) : undefined
                    }
                />
            </Stack.Item>
        </Stack>
    );
};
ResourceOwnerInfo.displayName = 'ResourceOwnerInfo';
